import { Blockquote, Button, Group, Text } from "@mantine/core";
import type { UseFormReturnType } from "@mantine/form";
import { IconPlus } from "@tabler/icons-react";
import type { ComponentProps } from "react";
import type { Grade } from "../../../models/enums/grade";
import type { EducationReportFormType } from "../form/EducationReportForm";
import { MeteredTextarea } from "../form/MeteredTextarea";
import type { EducationReportSelfAssessmentFormType } from "../selfAssessment/EducationReportSelfAssessmentForm";
import { GradingSection } from "./GradingSection";

export type GradingField<T> = {
  title: string;
  description?: string;
  key: keyof T;
};

type GradingSectionProps<T> = {
  baseNumber: number;
  fields: GradingField<T>[];
  form: UseFormReturnType<EducationReportFormType | EducationReportSelfAssessmentFormType>;
  remarksKey: string;
  remarksMaxLength?: ComponentProps<typeof MeteredTextarea<EducationReportFormType>>["maxLength"];
  path: string;
  baseKey?: "data" | "self_assessment";
  title?: string;
  disableNumbering?: boolean;
  gradeTranslations?: Record<Grade, string>;
  onObeservationLookup?: () => void;
  displaySelfAssessment?: boolean;
  remarksSelfAssessment?: string;
};

export function RemarkedGradingSection<T>({
  path,
  form,
  remarksKey,
  remarksMaxLength,
  onObeservationLookup,
  baseKey = "data",
  displaySelfAssessment,
  remarksSelfAssessment,
  ...props
}: GradingSectionProps<T>) {
  const label = (
    <Group justify="space-between">
      <Text>Bemerkungen</Text>
      {onObeservationLookup && (
        <Button variant="subtle" color="zli-blue" size="sm" leftSection={<IconPlus />} onClick={onObeservationLookup}>
          Beobachtung importieren
        </Button>
      )}
    </Group>
  );

  return (
    <GradingSection<T> form={form} path={path} baseKey={baseKey} displaySelfAssessment={displaySelfAssessment} {...props}>
      <MeteredTextarea<EducationReportFormType | EducationReportSelfAssessmentFormType>
        form={form}
        maxLength={remarksMaxLength}
        label={label}
        labelProps={{ w: "100%" }}
        path={`${baseKey}.${path}.${remarksKey}`}
      />
      {displaySelfAssessment && remarksSelfAssessment && (
        <Blockquote color="zli-orange">
          <Text>{remarksSelfAssessment}</Text>
        </Blockquote>
      )}
    </GradingSection>
  );
}
